import React from "react";
import barImage from "../images/bar.png";
import octoImage from "../images/octopus.png";
import wineImage from "../images/wine.png";

function EatImages() {
	return (
		<>
			<img
				src={barImage}
				alt="Kameni"
			/>
			<img
				src={wineImage}
				alt="Wine"
			/>
			<img
				src={octoImage}
				alt="Octopus"
			/>
		</>
	);
}

export default EatImages;
